module.exports = __webpack_public_path__ + "media/coffee-preferences/equitable_trade_i_mostly_want_these-e0c92eb2.png";